define('app/editor/ReportPage',['require','app/app','glu/layout','../visualizations/GridView','../visualizations/DonutChart','../visualizations/LineChart','../visualizations/BarChart','../visualizations/StackedBarChart','../visualizations/PieChart','../visualizations/ScatterPlot','../visualizations/PivotTable','../visualizations/ErrorView','glu/dialog','./dialogs/SaveReportDialogView','./dialogs/SaveMetricDialogView','./dialogs/SendLinkDialogView','./dialogs/SetAlertDialogView','./dialogs/EditAlertDialogView','./dialogs/FollowReportDialogView','app/app','glu/$','hbs!./ReportPage.hbs'],function(require) {
	'use strict';

	var APP = require('app/app'),
		Layout = require('glu/layout'),
		GridView = require('../visualizations/GridView'),
		DonutChart = require('../visualizations/DonutChart'),
		LineChart = require('../visualizations/LineChart'),
		BarChart = require('../visualizations/BarChart'),
		StackedBarChart = require('../visualizations/StackedBarChart'),
		PieChart = require('../visualizations/PieChart'),
		ScatterPlot = require('../visualizations/ScatterPlot'),
		PivotTable = require('../visualizations/PivotTable'),
		ErrorView = require('../visualizations/ErrorView'),
		dialog = require('glu/dialog'),
		SaveReportDialogView = require('./dialogs/SaveReportDialogView'),
		SaveMetricDialogView = require('./dialogs/SaveMetricDialogView'),
		SendLinkDialogView = require('./dialogs/SendLinkDialogView'),
		SetAlertDialogView = require('./dialogs/SetAlertDialogView'),
		EditAlertDialogView = require('./dialogs/EditAlertDialogView'),
		FollowReportDialogView = require('./dialogs/FollowReportDialogView'),
		App = require('app/app'),
		$ = require('glu/$');

	var noDesc = '(No description)';


	return Layout.extend({

		className: 'page-report',

		dialog: dialog,

		events: {
			'click #toggle-report-definition-button': 'toggleReportDefinition',
			'click [role="menuitemradio"]': 'clickAriaRadioButton',
			'click .report-export-csv': 'exportCsv',
			'click [data-qa="report-save"]': 'save',
			'click [data-qa="report-save-as"]': 'saveAs',
			'click .report-save-as-a-metric a': 'saveAsMetric',
			'click [data-qa="report-export"]': 'export',
			'click [data-qa="report-rename"]': 'rename',
			'click [data-qa="report-follow"], .social .follow': 'follow',
			'click [data-qa="report-send-link"]': 'sendLink',
			'click [data-qa="report-set-alert"]': 'setAlert',
			'click [data-qa="report-edit-alert"]': 'setAlert',
			'click [data-qa="report-delete"]': 'delete',
			'click [data-qa="report-make-public"], .social .share': 'togglePublicPrivate',
			'click .toggle-description': 'toggleDescription',
			'click .no-columns-message a, .no-columns-message button': 'openAddColumnDialog',
			'blur .report-name': 'updateReportName',
			'keydown .report-name': 'reportNameKeyEvents',
			'blur .description span': 'updateReportDescription',
			'focus .description span': 'clearReportDescription',
			'keydown .description span': 'reportDescriptionKeyEvents'
		},

		template: require('hbs!./ReportPage.hbs'),

		regions: {
			form: '#report-definition',
			results: '#report-results',
			filters: '#report-filters'
		},

		initialize: function() {
			var self = this;

			this.reportType = this.model.getReportType();

			this.listenTo(this.model, 'graphRendered', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'donutRendered', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'gridRendered', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'change', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'saved', function() {
				self.model.clean();
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'change:distribution', function() {
				self.model.set('isDirty', true);
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'linkSent', function() {
				this.dialog.alert('The link to this report has successfully been sent to the selected users.', 'Send Link');
			});

			this.listenTo(this.model, 'alertSet', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'change:name', this.renderName);

			this.listenTo(this.model, 'change:visualization', function() {
				this.switchToVisualization(this.model.getVisualization());
				self.selectCurrentViewButton();
				this.model.set('isDirty', true);
			});

			this.listenTo(this.appBus, 'refresh', function() {

				// Disable aggregation mode if there are no columns
				if (this.model.get('columnCollection').length === 0) {
					this.model.setGroupedAndAggregated(false);
				}

				// If ever the grid view is in a non runnable state, display an error message.
				// We should consider using this approach for all visualizations.
				if (this.model.getVisualization() === 'table' && this.model.isNotRunnable()) {
					this.switchToVisualization('error');
				} else {
					this.switchToVisualization(this.model.getVisualization());
					this.model.run();
				}

				this.refreshClassesAndStates();
			});

			this.listenTo(this.appBus, 'report:viewport:change', function() {
				self.renderResults();
			});

			if (!this.model.get('description') || this.model.get('description') === '' || this.model.get('description') === noDesc) {
				self.model.set('description', '');
			}
		},

		serializeData: function() {
			return this;
		},

		onRender: function() {
			if (this.reportDefinitionView) {
				this.form.show(this.reportDefinitionView);
			}
			if (this.filtersView) {
				this.filters.show(this.filtersView);
			}
			if (this.getVisualization(this.model.getVisualization())) {
				this.results.show(this.getVisualization(this.model.getVisualization()));
				this.refreshClassesAndStates();
			}
		},

		renderResults: function() {
			if (this.getVisualization(this.model.getVisualization())) {
				this.results.show(this.getVisualization(this.model.getVisualization()));
				this.refreshClassesAndStates();
			}
		},

		getVisualization: function(visualization) {
			switch (visualization) {
				case 'table':
					return this.getGridVisualization();
				case 'donut-chart':
					return this.getDonutVisualization();
				case 'line-chart':
					return this.getLineChartVisualization();
				case 'bar-chart':
					return this.getBarChartVisualization();
				case 'stacked-bar-chart':
					return this.getStackedBarChartVisualization();
				case 'pie-chart':
					return this.getPieChartVisualization();
				case 'scatter-plot':
					return this.getScatterPlotVisualization();
				case 'pivot-table':
					return this.getPivotTableVisualization();
				default:
					return this.getErrorVisualization();
			}
		},

		getGridVisualization: function() {
			return new GridView({
				model: this.model,
				id: 'report-results-grid'
			});
		},

		getDonutVisualization: function() {
			return new DonutChart({
				model: this.model,
				id: 'report-results-grid'
			});
		},

		isDonutWidget: function() {
			if (this.getVisualization === 'donut-chart') {
				return true;
			}
		},

		getLineChartVisualization: function() {
			return new LineChart({
				model: this.model
			});
		},

		getBarChartVisualization: function() {
			return new BarChart({
				model: this.model
			});
		},

		getStackedBarChartVisualization: function() {
			return new StackedBarChart({
				model: this.model
			});
		},

		getScatterPlotVisualization: function() {
			return new ScatterPlot({
				model: this.model
			});
		},

		getPieChartVisualization: function() {
			return new PieChart({
				model: this.model
			});
		},

		getPivotTableVisualization: function() {
			return new PivotTable({
				model: this.model
			});
		},

		getErrorVisualization: function() {
			return new ErrorView({
				hasNoColumns: this.model.hasNoColumns(),
				hasInvalidFilters: this.model.hasInvalidFilters()
			});
		},

		name: function() {
			return this.model.get('name');
		},

		renderName: function() {
			this.$('.report-name').text(this.name());
		},

		toggleReportDefinition: function(evt) {
			evt.preventDefault();
			this.$el.toggleClass('is-report-definition-collapsed');
			this.render();
		},

		switchToVisualization: function(name) {
			this.results.currentView.close();
			this.results.show(this.getVisualization(name));
		},

		rerenderResults: function() {
			if (this.results.currentView) {
				this.results.currentView.render();
			}
		},

		clickAriaRadioButton: function(evt) {
			evt.preventDefault();
			this.model.setVisualization(this.$(evt.target).val());
			this.refreshClassesAndStates();
		},

		refreshClassesAndStates: function() {
			var self = this;

			self.$el.toggleClass('is-grouping-hidden', !self.model.isGroupedAndAggregated());
			self.$el.toggleClass('no-columns', self.model.hasNoColumns());
			var $defineView = self.$el.find('.define-view');
			$defineView.toggleClass('is-runnable', self.model.isRunnable());
			$defineView.toggleClass('is-not-runnable', self.model.isNotRunnable());
			$defineView.toggleClass('has-rows', self.model.hasGroupColumns());
			$defineView.toggleClass('has-no-columns', self.model.hasNoColumns());
			self.$('#group-and-aggregate-checkbox').prop('checked', self.model.isGroupedAndAggregated());
			self.$('#group-and-aggregate-checkbox').prop('disabled', self.model.isNotRunnable());
			self.$('#show-count-group-checkbox').prop('checked', self.model.hasGroupCountColumn());
			self.$('#report-export-csv-button').prop('disabled', self.model.isNotRunnable());

			self.selectCurrentViewButton();

			self.updateSubmitButtonState();

			// Toggle report action options
			if (self.model.isSaved()) {
				self.$el.find('.report-options-more').show();
				self.$el.find('.report-save-button').show();
				self.$el.find('.report-save-button').removeClass('menu-hidden');

				if (self.model.isOwner()) {
					if (self.model.isDirty && self.model.isDirty() && self.model.isRunnable() && self.model.canRenderReport() && self.isValidWidget()) {
						self.$el.find('.report-save-button').removeClass('disabled');
						self.$el.find('.report-export-button').removeClass('disabled');
						self.$el.find('.report-save-button').html('Save');
					} else if (self.model.isDirty && self.model.isDirty() && (!self.model.isRunnable() || !self.model.canRenderReport() || !self.isValidWidget())) {
						self.$el.find('.report-save-button').addClass('disabled');
						self.$el.find('.report-export-button').addClass('disabled');
						self.$el.find('.report-save-button').html('Save');
					} else {
						self.$el.find('.report-save-button').addClass('disabled');
						self.$el.find('.report-export-button').removeClass('disabled');
						self.$el.find('.report-save-button').html('Saved');
					}
				} else {
					if (App.user.isInternalUser() && self.model.get('isPrivate')) {
						self.$el.find('.report-export-button').addClass('disabled');
						self.$el.find('.report-follow-button').addClass('disabled');
						self.$el.find('.report-save-button').html('Saved');
						self.$el.find('.report-save-button').addClass('disabled');
					} else if (App.user.isInternalUser() && !self.model.get('isPrivate')) {
						self.$el.find('.report-save-button').html('Saved');
						self.$el.find('.report-save-button').addClass('disabled');
					} else if (self.model.isRunnable() && self.model.canRenderReport() && self.isValidWidget()) {
						self.$el.find('.report-save-button').removeClass('disabled');
						self.$el.find('.report-export-button').removeClass('disabled');
						self.$el.find('.report-save-button').html('Save');
					} else {
						self.$el.find('.report-save-button').addClass('disabled');
						self.$el.find('.report-export-button').addClass('disabled');
						self.$el.find('.report-save-button').html('Save');
					}
				}
			} else {
				self.$el.find('.report-options-more').hide();
				self.$el.find('.report-save-button').show();
				self.$el.find('.report-save-button').addClass('menu-hidden');
				if (self.model.isDirty() && self.model.isRunnable() && self.model.canRenderReport() && self.isValidWidget()) {
					self.$el.find('.report-save-button').removeClass('disabled');
					self.$el.find('.report-save-button').html('Save');
				} else if (self.model.isDirty() && (!self.model.isRunnable() || !self.model.canRenderReport() || !self.isValidWidget())) {
					self.$el.find('.report-save-button').addClass('disabled');
					self.$el.find('.report-save-button').html('Save');
				} else {
					self.$el.find('.report-save-button').removeClass('disabled');
					self.$el.find('.report-save-button').html('Save');
				}
			}

			if (this.model.getVisualization() === 'donut-chart') {
				if (self.isValidDonut()) {
					self.$el.find('.report-set-alert').removeClass('disabled');
					self.$el.find('.alert-item').removeClass('disabled');
					self.$el.find('.report-save-as-a-metric').removeClass('disabled');
				} else {
					self.$el.find('.report-set-alert').addClass('disabled');
					self.$el.find('.alert-item').addClass('disabled');
					self.$el.find('.report-save-as-a-metric').addClass('disabled');
				}
			} else {
				self.$el.find('.report-set-alert').addClass('disabled');
				self.$el.find('.alert-item').addClass('disabled');
				self.$el.find('.report-save-as-a-metric').addClass('disabled');
			}

			if (!self.model.get('description') || self.model.get('description') === '' || self.model.get('description') === noDesc) {
				$('.description span').text(noDesc);
				$('.description span').addClass('no-desc');
			} else {
				$('.description span').text(self.model.get('description'));
				$('.description span').removeClass('no-desc');
			}

			if (self.isPublic()) {
				self.$el.find('.report-make-public').text('Remove public access');
				self.$el.find('.share').show();
				if (self.$el.find('.report-send-link').length) {
					self.$el.find('.report-send-link').parent().removeClass('disabled');
				}
			} else {
				self.$el.find('.report-make-public').text('Make public');
				self.$el.find('.share').hide();
				if (self.$el.find('.report-send-link').length) {
					self.$el.find('.report-send-link').parent().addClass('disabled');
				}
			}

			if (self.isFollowing() || self.isAlertReport()) {
				self.$el.find('.report-follow').text('Follow preferences...');
				self.$el.find('.follow').html('<i class="icon-clock"></i>' + self.getFrequency());
				self.$el.find('.follow').show();
			} else {
				self.$el.find('.report-follow').text('Follow...');
				self.$el.find('.follow').html('');
				self.$el.find('.follow').hide();
			}

			// display export as csv
			var visType = this.model.getVisualization();
			if (this.model.isValid() && this.model.canRenderReport() && (visType === 'pivot-table' || visType === 'table')) {
				self.$el.find('.report-export-csv-button').removeClass('disabled');
				self.$el.find('.report-export-csv').removeClass('disabled');
			} else {
				self.$el.find('.report-export-csv-button').addClass('disabled');
				self.$el.find('.report-export-csv').addClass('disabled');
			}
		},

		isValidWidget: function() {
			var widgetType = this.model.getWidgetType();
			if (widgetType) {
				if (widgetType === 'KPI') {
					return this.model.hasKpi();
				}
				if (widgetType === 'TOP10') {
					return this.model.hasTop10ListResults();
				}
			}
			return true;
		},

		isValidDonut: function() {
			var widgetType = this.getWidgetType();
			if (widgetType && widgetType === 'DONUT') {
				var value = this.model.canRenderReport();
				return value;
			}
			return false;
		},

		isMetric: function() {
			return this.model.isMetric();
		},

		updateSubmitButtonState: function() {
			if (this.model.isRunnable()) {
				this.enableSubmitButton();
			} else {
				this.disableSubmitButton();
			}
		},

		submitButton: function() {
			return this.$el.find('[type=submit]');
		},

		enableSubmitButton: function() {
			this.submitButton().removeAttr('disabled');
		},

		disableSubmitButton: function() {
			this.submitButton().attr('disabled', 'disabled');
		},

		selectCurrentViewButton: function() {
			var $button = this.$el.find('.report-view-buttons [value="' + this.model.getVisualization() + '"]');
			$button.closest('[role=menubar]').find('[role=menuitemradio]').attr('aria-selected', false);
			$button.attr('aria-selected', true);
		},

		domainName: function() {
			return this.model.getDomainName();
		},

		reportName: function() {
			return this.model.getName();
		},

		reportDescription: function() {
			return this.model.getDescription();
		},

		save: function(e) {
			var self = this;

			e.preventDefault();

			// Save is not allowed for internal users
			if (App.user.isInternalUser()) {
				return;
			}

			if ((this.model.isDirty() || !self.model.isSaved() || !self.model.isOwner()) && this.model.isValid() && this.model.canRenderReport()) {
				if (this.model.isSaved() && self.model.isOwner() && !this.model.getWidgetType()) {
					this.model.set('saveInProgress', true, {
						silent: true
					});

					this.model.set('recentlyImported', undefined, {
						silent: true
					});

					// If a widget exists, reset as new widget type
					if (this.model.getWidgetType()) {
						this.model.setWidgetType(this.getWidgetType());
					}

					if (this.model.getDescription() === noDesc) {
						this.model.set('description', '', {
							silent: true
						});
					}

					self.model.save().then(function() {
						self.model.set('saveInProgress', false, {
							silent: true
						});

						self.model.clean();

						self.refreshClassesAndStates();
					});
				} else {
					this.saveAs(e, false);
				}
			}
		},

		getWidgetType: function() {
			switch (this.model.getVisualization()) {
				case 'bar-chart':
					return 'BARCHART';
				case 'stacked-bar-chart':
					return 'STACKEDBARCHART';
				case 'line-chart':
					return 'LINECHART';
				case 'scatter-plot':
					return 'SCATTERPLOT';
				case 'pie-chart':
					return 'PIECHART';
				case 'donut-chart':
					return 'DONUT';
				case 'table':
					// a table can be saved in one of two ways.  We first need to determine which widget type
					// is appropriate given the current state of the report.
					if (this.model.hasKpi()) {
						return 'KPI';
					} else if (this.model.hasTop10ListResults()) {
						return 'TOP10';
					}
			}
		},

		saveAs: function(e, setSaveAs) {
			var self = this;
			e.preventDefault();

			if (this.model.getDescription() === noDesc) {
				this.model.set('description', '', {
					silent: true
				});
			}

			var checkSaveAs = (setSaveAs === false) ? false : true;
			if (self.model.isRunnable()) {
				this.dialog.open(new SaveReportDialogView({
					model: this.model,
					className: 'modal-save-report',
					saveAs: checkSaveAs,
					type: this.reportType
				}));
			}
		},

		saveAsMetric: function(e) {
			var self = this;
			e.preventDefault();

			if (this.model.getDescription() === noDesc) {
				this.model.set('description', '', {
					silent: true
				});
			}

			if (self.isValidDonut()) {
				this.dialog.open(new SaveMetricDialogView({
					model: this.model,
					className: 'modal-save-metric',
					saveAs: true,
					noname: false,
					type: this.reportType
				}));
			}
		},

		rename: function(e) {
			e.preventDefault();
			this.$el.find('.report-name').focus().select();
		},

		export: function(e) {
			var self = this,
				textFile;

			e.preventDefault();

			if (this.model.isRunnable() && (!this.$(e.target).parent().hasClass('disabled'))) {
				dialog.confirm('Exporting the report will save it to a downloadable text file, which can be sent to others to import. Are you sure you want to do this?', 'Export report', function(ok) {
					if (ok) {
						self.model.exportJson().then(function(res) {

							var reportName = self.model.getName();
							if (window.navigator.msSaveBlob) { // IE 10+
								textFile = new Blob([res], {
									type: 'text/plain;charset=utf-8;'
								});
								var url = navigator.msSaveBlob(textFile, reportName + '_export.txt');
								var tempLink = document.createElement('a');
								tempLink.href = url;
								tempLink.setAttribute('download', reportName + '_export.txt');
								tempLink.click();
							} else {
								textFile = 'data:text/plain;charset=utf-8,' + encodeURIComponent(res);
								var link = document.createElement('a');
								if (typeof link.download === 'string') {
									document.body.appendChild(link); // Firefox requires the link to be in the body
									link.download = reportName + '_export.txt';
									link.href = textFile;
									link.click();
									document.body.removeChild(link); // remove the link when done
								} else {
									location.replace(textFile);
								}
							}
						});
					}
				});
			}
		},

		follow: function(e) {
			e.preventDefault();
			this.dialog.open(new FollowReportDialogView({
				model: this.model,
				className: 'modal-follow-report'
			}));
		},

		sendLink: function(e) {
			e.preventDefault();
			// Make sure menu item isn't disabled
			if (!this.$(e.target).parent().hasClass('disabled')) {
				this.dialog.open(new SendLinkDialogView({
					model: this.model,
					className: 'modal-send-link'
				}));
			}
		},

		setAlert: function(e) {
			e.preventDefault();
			// Make sure menu item isn't disabled
			if (!this.$(e.target).parent().hasClass('disabled')) {
				if (this.hasThreshold()) {
					if (!this.isValidDonut()) {
						dialog.error('The report is not a valid donut widget at the moment. You cannot edit the alert!');
					} else {
						this.dialog.open(new EditAlertDialogView({
							model: this.model,
							className: 'modal-edit-alert'
						}));
					}
				} else {
					if (this.isValidDonut()) {
						this.dialog.open(new SetAlertDialogView({
							model: this.model,
							className: 'modal-set-alert'
						}));
					}
				}
			}
		},

		toggleDescription: function(e) {
			e.preventDefault();
			this.$el.find('.description').fadeToggle('fast');
		},

		togglePublicPrivate: function(e) {
			var self = this,
				publicOrPrivate = '',
				confirmMessage = '';

			e.preventDefault();
			if (!this.isOwner()) {
				dialog.error('"' + this.getReportOwner() + '" owns this report and only they can make changes to the report.');
				return;
			}

			if (this.model.get('isPrivate')) {
				publicOrPrivate = 'public';
				confirmMessage = 'Allowing public access will also save all changes made to the report. A public report will be accessible by all users in the organization. Are you sure you want to do this?';
			} else {
				publicOrPrivate = 'private';

				// check if it is in a public dashboard
				var dashboardId = this.model.getDashboardId();
				var dashboard = App.dashboards.filter(function(d) {
					return d.get('id') === dashboardId;
				});

				if (dashboard && dashboard.length > 0 && !dashboard[0].get('isPrivate')) {
					dialog.error('The report is part of a public dashboard. You will need to remove public access to the dashboard before you can change the public access settings for this individual report.');
					return;
				}

				confirmMessage = 'Removing public access will also save all changes made to the report. A private report will be inaccessible by all other users in the organization. Anyone following this report will no longer receive scheduled notifications. Are you sure you want to do this?';
			}

			dialog.confirm(confirmMessage, 'Make report ' + publicOrPrivate, function(ok) {
				if (ok) {
					if (self.model.get('isPrivate')) {
						self.model.setIsPrivate(false);
					} else {
						self.model.setIsPrivate(true);
					}
					self.refreshClassesAndStates();
				}
			});
		},

		delete: function(e) {
			var self = this;
			var cid = self.model.cid;

			e.preventDefault();

			var eName = (self.model.getReportType() === 'ALERT') ? 'alert' : 'report';
			var reportMsg = 'Anyone following this report will no longer receive scheduled notifications. Are you sure you want to delete this report?';
			var alertMsg = 'You will no longer receive scheduled notifications. Are you sure you want to delete this alert?';
			var caption = 'Delete ' + eName;
			var msg = (self.model.getReportType() === 'ALERT') ? alertMsg : reportMsg;

			dialog.confirm(msg, caption, function(ok) {
				if (ok) {
					self.model.delete().then(function() {
						APP.openReports.remove(cid);
						self.navigateTo('/dashboard');
					});
				}
			});
		},

		isValid: function() {
			return this.model.isValid();
		},

		isOwner: function() {
			return this.model.isOwner();
		},

		getReportOwner: function() {
			return this.model.get('owner');
		},

		isPublic: function() {
			return this.model.get('isPrivate') === false;
		},

		hasThreshold: function() {
			return this.model.get('threshold') !== undefined;
		},

		getFrequency: function() {
			var output;
			if (this.isAlertReport() && this.model.getThreshold().schedule) {
				output = this.model.getThreshold().schedule.toLowerCase();
			} else {
				output = this.model.getDistrData().schedule.toLowerCase();
			}
			return output.charAt(0).toUpperCase() + output.slice(1);
		},

		isFollowing: function() {
			return this.model.get('isFollowing');
		},

		exportCsv: function(evt) {
			evt.preventDefault();
			var visType = this.model.getVisualization();
			if (this.model.isValid()) {
				if (visType === 'pivot-table') {
					var pivot = this.getPivotTableVisualization();
					var csvData = pivot.getCSV();
					var reportName = this.model.getName();
					if (window.navigator.msSaveBlob) { // IE 10+
						var csvURL = navigator.msSaveBlob(csvData, reportName + '_pivot.csv');
						var tempLink = document.createElement('a');
						tempLink.href = csvURL;
						tempLink.setAttribute('download', reportName + '_pivot.csv');
						tempLink.click();
					} else {
						var link = document.createElement('a');
						if (typeof link.download === 'string') {
							document.body.appendChild(link); // Firefox requires the link to be in the body
							link.download = reportName + '_pivot.csv';
							link.href = csvData;
							link.click();
							document.body.removeChild(link); // remove the link when done
						} else {
							location.replace(csvData);
						}
					}
				} else {
					this.model.exportCsv();
				}
			}
		},

		openAddColumnDialog: function(e) {
			e.preventDefault();

			// Use an existing event
			$('#select-columns-button').click();
		},

		updateReportName: function(e) {
			var name = !$(e.target).text() || $(e.target).text().trim() === '' ? 'Untitled Report' : $(e.target).text();
			this.model.set('name', name);
			$(e.target).text(name);
			this.refreshClassesAndStates();
		},

		reportNameKeyEvents: function(e) {
			if (e.keyCode === 13) {
				e.preventDefault();
				this.$el.find('.report-name').blur();
			} else if (e.keyCode === 27) {
				e.preventDefault();
				$(e.target).text(this.model.get('name'));
				this.$el.find('.report-name').blur();
			}
		},

		updateReportDescription: function(e) {
			var description = !$(e.target).text() || $(e.target).text().trim() === '' ? noDesc : $(e.target).text();

			this.model.set('description', description);
			$(e.target).text(description);
			this.refreshClassesAndStates();
		},

		clearReportDescription: function(e) {
			if ($(e.target).text() === noDesc) {
				$(e.target).text('');
			}
		},

		isRecentlyImported: function() {
			return this.model.get('recentlyImported');
		},

		showFullAccess: function() {
			return !this.isRecentlyImported() && this.isOwner();
		},

		isAlertReport: function() {
			return (this.model.getReportType() === 'ALERT');
		},

		reportDescriptionKeyEvents: function(e) {
			if (e.keyCode === 13) {
				e.preventDefault();
				this.$el.find('.description span').blur();
			} else if (e.keyCode === 27) {
				e.preventDefault();
				$(e.target).text(this.model.get('description'));
				this.$el.find('.description span').blur();
			}
		},

		hasDashboard: function() {
			return !!this.model.get('dashboardId');
		},

		getDashboardName: function() {
			var dashboardId = this.model.get('dashboardId');
			var dashboardArr = App.dashboards.filter(function(d) {
				return d.get('id') === dashboardId;
			});
			if (dashboardArr.length > 0) {
				var dashboard = dashboardArr[0];
				return dashboard.get('name') || dashboardId;
			} else {
				return 'Shared';
			}
		}
	});

});

